import React from "react";

const StatCard = ({
  title,
  value,
  change,
  changeColor = "default",
  icon = "📊",
}) => {
  const colorMap = {
    success: "text-green-600",
    warning: "text-orange-500",
    error: "text-red-600",
    info: "text-blue-600",
    default: "text-gray-500",
  };

  const bgColorMap = {
    success: "bg-green-50",
    warning: "bg-orange-50",
    error: "bg-red-50",
    info: "bg-blue-50",
    default: "bg-gray-50",
  };

  return (
    <div className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow p-4 border border-gray-100">
      <div className="flex items-start justify-between mb-3">
        <h3 className="text-gray-600 text-sm font-medium bg-white">{title}</h3>
        <span className={`text-2xl ${bgColorMap[changeColor]} p-2 rounded-lg`}>
          {icon}
        </span>
      </div>
      <p className="text-2xl font-bold text-gray-900 mb-2">{value}</p>
      <p className={`text-xs font-medium ${colorMap[changeColor]}`}>{change}</p>
    </div>
  );
};

export default StatCard;
